import { render, staticRenderFns } from "./OrganismLogout.vue?vue&type=template&id=25e06095"
import script from "./OrganismLogout.vue?vue&type=script&lang=js"
export * from "./OrganismLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports